import React, { useCallback } from "react";
import { Helmet } from "react-helmet"; // ADD THIS IMPORT
import "../../css/Home.css";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ServiceNavigation from "./ServiceNavigation";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import config from "../../../config";
import Services from "../../../ProviderServices.json";
import { Button } from "@mui/material";
import ThurentEventForm from "../ThurentEventForm";
import OfferingsSection from "./OfferingSection";
import { offeringsData } from './OfferingData';
import HeroSection from "./HeroSection";
import { HeroSectionData } from './HeroSectionData';
import { eventServicesSeoMappings } from "./seoMappings"; // ADD THIS IMPORT

function SendInvitationService({ invitationType = "default" }) { // ADD prop
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get invitation type from EITHER:
  // 1. prop (for clean URLs like /online-invitation-maker)
  // 2. query parameter (for /service/invite?type=digital-invitation)
  const params = new URLSearchParams(location.search);
  const queryInvitationType = params.get("type");
  
  // Priority: Query param > Prop
  const finalInvitationType = queryInvitationType || invitationType;
  
  // Get SEO data
  const seoData = eventServicesSeoMappings[finalInvitationType] || eventServicesSeoMappings.default;

  // Offerings Section
  const { heading, subHeading, list, image,
    ABOUT_SECTION_TITLE,ABOUT_SECTION_SUBTITLE,ABOUT_SECTION_DESC,alt } = offeringsData.sendInvitation;

  const service = Services.find((service) =>
    location.pathname.includes(service.slug)
  );

  return (
    <>
      {/* ADD HELMET HERE */}
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      
      <Navbar />
      <ServiceNavigation />
      <div className="th-service">
        <HeroSection
          service={service}
          providerListStorageKey={config.providerListStorageKey}
          data={HeroSectionData.sendInvitation}
        />
        <div className="flex mt-5 justify-content-center lg:mt-0">
          <div
            className="event-form th-plan"
            style={{
              boxShadow: "none",
            }}
          >
            <ThurentEventForm />
          </div>
        </div>
      </div>
      <OfferingsSection
        heading={heading}
        subHeading={subHeading}
        offeringsList={list}
        image={image} 
        ABOUT_SECTION_TITLE={ABOUT_SECTION_TITLE}
        ABOUT_SECTION_SUBTITLE={ABOUT_SECTION_SUBTITLE}
        ABOUT_SECTION_DESC={ABOUT_SECTION_DESC}
        altdata ={alt}
      />     
      <ConfirmDialog />
      <Footer />
    </>
  );
}

export default SendInvitationService;